export const inputCls =
  "w-full h-10 rounded-md border border-[#D1D5DB] bg-white px-3 text-[14px] outline-none focus:border-[#111] focus:ring-2 focus:ring-[#F8D481]/40 transition-colors disabled:bg-[#F3F4F6]";
export const textareaCls = `${inputCls} h-auto py-2 min-h-[110px] resize-y leading-relaxed`;
export const selectCls = `${inputCls} pr-8`;
export const btnPrimary =
  "inline-flex items-center justify-center gap-1.5 h-10 px-4 rounded-md bg-[#F8D481] hover:bg-[#f2c968] text-black text-[14px] font-semibold disabled:opacity-50 disabled:cursor-not-allowed transition-colors";
export const btnSecondary =
  "inline-flex items-center justify-center gap-1.5 h-10 px-4 rounded-md border border-[#D1D5DB] bg-white hover:bg-[#F3F4F6] text-[14px] font-medium disabled:opacity-50 transition-colors";
export const btnDanger =
  "inline-flex items-center justify-center gap-1.5 h-10 px-4 rounded-md border border-[#FECACA] bg-white hover:bg-[#FEF2F2] text-[#B91C1C] text-[14px] font-medium transition-colors";
export const btnSmall = "inline-flex items-center h-8 px-3 rounded-md border border-[#D1D5DB] bg-white hover:bg-[#F3F4F6] text-[13px] font-medium disabled:opacity-40 transition-colors";
export const card = "bg-white border border-[#E5E7EB] rounded-lg";
export const linkCls = "text-[#3B5BDB] hover:underline";

export const Field = ({ label, hint, children, className = "" }) => (
  <label className={`block ${className}`}>
    <span className="block text-[13px] font-semibold text-[#111] mb-1.5">{label}</span>
    {children}
    {hint && <span className="block mt-1 text-[12px] text-[#6B7280]">{hint}</span>}
  </label>
);

export const PageTitle = ({ title, children }) => (
  <div className="flex flex-wrap items-center justify-between gap-3 mb-6">
    <h1 className="text-[20px] md:text-[24px] font-semibold" data-testid="admin-page-title">
      {title}
    </h1>
    <div className="flex flex-wrap items-center gap-2">{children}</div>
  </div>
);

export const TableWrap = ({ children, minWidth = 760, testId }) => (
  <div className={`${card} overflow-hidden`} data-testid={testId}>
    <div className="overflow-x-auto">
      <div style={{ minWidth }}>{children}</div>
    </div>
  </div>
);

export const Badge = ({ children, tone = "gray" }) => {
  const tones = {
    gray: "bg-[#F3F4F6] text-[#374151]",
    green: "bg-[#DCFCE7] text-[#166534]",
    yellow: "bg-[#FEF3C7] text-[#92400E]",
    red: "bg-[#FEE2E2] text-[#991B1B]",
    blue: "bg-[#DBEAFE] text-[#1E40AF]",
  };
  return <span className={`inline-flex items-center rounded px-2 py-0.5 text-[11px] font-semibold uppercase tracking-wide ${tones[tone]}`}>{children}</span>;
};

export const statusTone = (status) => ({ ready: "green", processing: "yellow", uploading: "blue", error: "red" }[status] || "gray");

export const Toggle = ({ checked, onChange, testId }) => (
  <button
    type="button"
    role="switch"
    aria-checked={checked}
    onClick={() => onChange(!checked)}
    className={`relative h-6 w-11 shrink-0 rounded-full transition-colors ${checked ? "bg-[#B644DC]" : "bg-[#D1D5DB]"}`}
    data-testid={testId}
  >
    <span className={`absolute top-0.5 h-5 w-5 rounded-full bg-white shadow transition-all ${checked ? "left-[22px]" : "left-0.5"}`} />
  </button>
);
